export const EditorText = {
  sidebarCourseName: 'Course',
};
